// Firebase Configuration - SHARED with Magnus-Core
// Uses the same Firebase project for auth and Firestore

import { initializeApp, getApps, getApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider, connectAuthEmulator } from 'firebase/auth';
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';
import { getAnalytics, Analytics } from 'firebase/analytics';

// Explicit emulator flag - must be set to 'true' to use emulators
const USE_EMULATOR = import.meta.env.VITE_USE_FIREBASE_EMULATOR === 'true';

// Production Firebase configuration (SAME as Magnus-Core)
const firebaseConfig = {
    apiKey: "AIzaSyBHO1SDc3-ZTtTsoTHCh5zbDU1MoaHkCq4",
    authDomain: "dfr-living-reliability-system.firebaseapp.com",
    projectId: "dfr-living-reliability-system",
    storageBucket: "dfr-living-reliability-system.firebasestorage.app",
    messagingSenderId: "933555815330",
    appId: "1:933555815330:web:12d238ed7f5ff1671228fb",
    measurementId: "G-DBQM4WJ9S3"
};

// Initialize Firebase (Singleton pattern)
let app;
let analytics: Analytics | null = null;

if (getApps().length === 0) {
    app = initializeApp(firebaseConfig);

    console.log('🔥 Magnus Resolve - Firebase Configuration:');
    console.log(`   → Project: ${firebaseConfig.projectId}`);
    console.log(`   → Use Emulator: ${USE_EMULATOR}`);

    if (USE_EMULATOR) {
        const auth = getAuth(app);
        connectAuthEmulator(auth, "http://127.0.0.1:9099", { disableWarnings: true });

        const db = getFirestore(app);
        connectFirestoreEmulator(db, '127.0.0.1', 8080);

        console.log('🔧 EMULATOR MODE: Connected to Firebase Emulators');
    } else {
        console.log('✅ PRODUCTION MODE: Using Firebase Cloud Services');

        try {
            analytics = getAnalytics(app);
            console.log('📊 Analytics enabled');
        } catch (e) {
            console.warn('Analytics initialization failed:', e);
        }
    }
} else {
    app = getApp();
}

// Auth (shared with Magnus-Core)
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();

// Firestore (shared database)
export const db = getFirestore(app);

export { app, analytics };
export default app;
